import React, { Component } from 'react';
import { LoginStyle } from './loginComp';
import request from 'utils/request';
import { setCookie, getCookie, baiduStatistics, imageUrl } from 'utils';
import { message } from 'antd';
import $ from 'jquery';
import 'utils/gVerify';
import { global } from 'config';

export default class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: getCookie('token'),
            chooseFlag: true,
            captchaFlag: true,
            login_mobile: '',
            verify: '',
            flag: false,
            v_code: '',
            mask: false
        }
    }

    componentDidMount() {
        const { token } = this.state;
        const { push } = this.props.history;

        if (token) {
            push('/platform');
        }

        baiduStatistics();
        this.requestGraphic();
    }

    // 登录
    goLogin = () => {
        const { chooseFlag, login_mobile, verify, flag } = this.state;

        const { push } = this.props.history;

        if (chooseFlag) {
            if (login_mobile.length !== 11) {
                message.error('请输入正确的手机号');
                return;
            }

            if (!flag) {
                message.error('请输入图形码');
                return;
            }



            if (!verify) {
                message.error('请输入验证码');
                return;
            }
            request({
                url: 'huhuapi/NewStartup/anchorPlatformLogin',
                data: {
                    // login_mobile: 13362909602,
                    // verify: 301311
                    login_mobile,
                    verify
                }
            }).then(res => {
                // console.log(res.data);

                if (res.data.status) {
                    let token = JSON.stringify({
                        anchor_data: res.data.msg.anchor_data,
                        sign: res.data.msg.sign
                    });
                    setCookie('token', token);

                    message.success('登录成功', 1.5, () => {
                        push('/platform');
                    })
                } else {
                    message.error(res.data.msg);
                }
            }).catch(err => console.log(err));
        } else {
            message.error('请先勾选协议');
        }
    }

    // 
    changeChooseFlag = () => {
        const { chooseFlag } = this.state;

        this.setState({
            chooseFlag: !chooseFlag
        });
    }

    check = e => {
        const { code } = this.state;

        if (e.target.value.toLocaleLowerCase() === code.toLocaleLowerCase()) {
            // console.log(e.target.value);
            this.setState({
                flag: true,
                v_code: e.target.value.toLocaleLowerCase()
            });
        } else {
            this.setState({
                flag: false,
                v_code: e.target.value.toLocaleLowerCase()
            });
        }
        // let verifyCode = new window.GVerify({
        //     id: "v_container",
        //     txtArr
        // });

        // let _this = this;
        // document.getElementById("code_input").onChange = function () {
        //     let res = verifyCode.validate(document.getElementById("code_input").value);
        //     if (res) {
        //         message.success('验证正确', 1.5, () => {
        //             _this.requestCaptcha(txtArr);
        //         });
        //     } else {
        //         message.error('验证码错误', 1, () => {
        //             document.getElementById("code_input").value = '';
        //             _this.requestGraphic();
        //         });
        //     }
        // }
    }

    // 获取图形码
    requestGraphic = type => {
        let ident = Date.now();

        this.setState({
            ident
        });

        request({
            url: 'huhuapi/startup/sendSms',
            data: {
                type: 1,
                ident
            }
        }).then(res => {
            // console.log(res.data);
            if (res.data.status) {
                // $('#code_input').val();
                this.setState({
                    code: res.data.msg,
                    flag: false,
                    v_code: ''
                });
                new window.GVerify({
                    id: "v_container",
                    txtArr: res.data.msg
                });
                // this.check(res.data.msg);
            } else {
                message.error(res.data.msg);
            }
        }).catch(err => console.log(err));
    }

    // 
    handleClick = () => {
        const { captchaFlag } = this.state;

        if (captchaFlag) {
            // 获取时间戳
            this.countdown();
            this.setState({
                captchaFlag: false,
            });

            // this.requestGraphic(1);
            this.requestCaptcha();

        }
    }

    // 获取验证码
    requestCaptcha = () => {
        const { login_mobile, ident, code } = this.state;

        request({
            url: 'huhuapi/startup/sendSms',
            data: {
                login_mobile,
                type: 2,
                ident,
                code
            }
        }).then(res => {
            // console.log(res.data);
            if (res.data.status) {

            } else {
                message.error(res.data.msg);
            }
        }).catch(err => console.log(err));
    }

    // 60s倒计时
    countdown = () => {
        let sec = 60;
        let timer = setInterval(() => {
            if (sec === 0) {
                clearInterval(timer);
                this.setState({
                    captchaFlag: true
                });
                return;
            }

            sec--;
            $('.captcha-text').html(`重新发送(${sec})`);
        }, 1000)

    }

    // 受控组件
    write = key => e => {
        this.setState({
            [key]: e.target.value,
        });
    }

    changeMask = () => {
        const { mask } = this.state;

        this.setState({
            mask: !mask
        });
    }

    render() {
        const { chooseFlag, flag, captchaFlag, login_mobile, verify, v_code, mask } = this.state;

        const { history: { push } } = this.props;

        return (<LoginStyle>
            <div className="login-kfpt">
                <header className="login-header">
                    <div className="wrapper">
                        <img src={require('images/home/logo.png')} onClick={() => push('/home')} className="login-logo" alt="" />
                        <div className="login-header-right">
                            <div className="entry" onClick={() => push('/platform/album')}>主播入口</div>
                            <div className="down" onClick={this.changeMask}>下载APP</div>
                        </div>
                    </div>
                </header>
                <div className="login-main">
                    <img className="login-img" src={imageUrl('https://huhuapp-images.huhustory.com/open/Public/Uploads/202006/bc1f77176ce57ecbdfd44561ce38c16d.png')} alt="" />
                    <div className="login-table">
                        <div className="theme">
                            <img className="logo" src={require('images/login/login-logo.png')} alt="" />
                            <div className="con">
                                <div className="con-t">欢迎来到呼呼收音机</div>
                                <div className="con-b">主播开放平台</div>
                            </div>
                        </div>
                        <div className="phone-con">
                            <input className="phone" placeholder="输入手机号" maxLength='15' value={login_mobile} onChange={(e) => this.write('login_mobile')(e)} />
                            <div className="tip">+86</div>
                        </div>
                        <div className="graphic">
                            <input type="text" id="code_input" onChange={this.check} value={v_code} placeholder="输入图形码" maxLength="4" />
                            <div id="v_container" style={{ width: '150px', height: '50px' }} onClick={this.requestGraphic}></div>
                            {flag ? <img className="right" src={require('images/login/chosen.png')} alt="right" /> : ""}
                        </div>
                        <div className="captcha">
                            <input className="captcha-inp" placeholder="输入验证码" maxLength='6' value={verify} onChange={(e) => this.write('verify')(e)} />
                            <div className="captcha-text" onClick={login_mobile.length === 11 && flag ? this.handleClick : () => { message.info('请先输入正确手机号和图形码') }} style={{ background: !captchaFlag ? '#bdbdbd' : '', boxShadow: !captchaFlag ? 'none' : '' }}>{captchaFlag ? '发送验证码' : '重新发送(60)'}</div>
                        </div>
                        <div className={login_mobile.length === 11 && verify && flag ? "login-btn" : "login-btn no-btn"} onClick={this.goLogin}>登录</div>
                        <div className="login-tip">未注册用户首次登录可完成注册</div>
                        <div className="login-agree">
                            <img alt="" className="agree" style={{ border: chooseFlag ? 0 : '' }} onClick={this.changeChooseFlag} src={chooseFlag ? require('images/login/chosen.png') : ''} />
                            <div className="agreement">我已阅读并接受<a href={global.href + "simple/user"} target="_blank" rel="noopener noreferrer"> 《用户服务协议》 </a>和<a href={global.href + "simple/privacy"} target="_blank" rel="noopener noreferrer"> 《隐私政策》 </a></div>
                        </div>

                    </div>
                </div>
            </div>

            {mask && <div className="mask">
                <div className="mask-dg" onClick={this.changeMask}></div>
                <div className="mask-con">
                    <img alt="" src={require('images/home/ssssss.png')} className="icon" />
                    <img alt="" src={require('images/home/huhustory.png')} className="down" />
                    <div className="title">扫码下载呼呼收音机收听更多故事</div>
                    <img src={require('images/home/close.png')} className="close" alt="" onClick={this.changeMask} />
                </div>
            </div>}
        </LoginStyle >);
    }
}
